import { render } from "./CommunityOrganizations.vue?vue&type=template&id=c596a3e0&scoped=true&lang=pug"
import script from "./CommunityOrganizations.vue?vue&type=script&lang=js"
export * from "./CommunityOrganizations.vue?vue&type=script&lang=js"

import "./CommunityOrganizations.vue?vue&type=style&index=0&id=c596a3e0&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c596a3e0"]])

export default __exports__